/**
 * Intl en fr-FR sépare les milliers par une espace fine insécable (U+202F) que la
 * police du site rend presque invisible : « 3 650,00 € » se lit « 3650,00 € ». On
 * la remplace par une espace insécable (U+00A0), comme `formatCurrency` dans l'app
 * mobile. À appliquer à tout montant formaté par Intl ou `toLocaleString("fr-FR")`.
 */
export const withVisibleThousands = (formatted: string): string => formatted.replace(/\u202F/g, "\u00A0");

/**
 * Formats a number as a euro amount with two decimal places.
 * @param amount - The amount to format
 * @returns The formatted amount (e.g., "10.00 €")
 */
export const formatEuro = (amount: number): string => {
  const localizedAmount = amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${withVisibleThousands(localizedAmount)} €`;
};

/**
 * Formats an amount stored in cents as a euro amount with two decimal places.
 * @param cents - The amount in cents
 * @returns The formatted amount (e.g., "45,00 €")
 */
export const formatPriceCents = (cents: number): string => formatEuro(cents / 100);

/**
 * Formats a number as a euro amount and with two decimal only if decimal is higher than 0
 * @param amount - The amount to format
 * @returns The formatted amount (e.g., "10 €" or "10,50 €")
 */
export const formatEuroWithDecimalOnlyIfNeeded = (amount: number): string => {
  const isIntegerAmount = Number.isInteger(amount);
  const formattedAmount = isIntegerAmount
    ? amount.toLocaleString("fr-FR")
    : amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${withVisibleThousands(formattedAmount)} €`;
};
